import React, { useCallback } from 'react';

// Renders phone numbers via a ref so browser extensions (e.g. Aircall "Highlight phone numbers")
// that mutate the DOM don't conflict with React's reconciliation.
export function PhoneText({
  children,
  ...props
}) {
  const ref = useCallback(node => {
    if (node) node.textContent = children ?? '';
  }, [children]);
  return <span ref={ref} {...props} />;
}